import { createFileRoute, redirect } from '@tanstack/react-router';

import MyPage from '@/pages/myPage/MyPage';

type MyPageSearch = {
  page?: number;
};

export const Route = createFileRoute('/my-page')({
  component: () => <MyPage />,

  validateSearch: (search: Record<string, unknown>): MyPageSearch => {
    return {
      page: Number(search.page) || 1,
    };
  },

  beforeLoad: async ({ context, location }) => {
    if (!context.isLoggedIn) {
      sessionStorage.setItem('redirectAfterLogin', location.href);
      throw redirect({ to: '/sign-in' });
    }
  },
});
